(function () {
  'use strict';

  var cfg = window.CandyAlcoholAgeGateConfig || {};
  var STORAGE_KEY = cfg.storageKey || 'candyonline_alcohol_18_session';
  var HOME_URL = cfg.homeUrl || '/';
  var modal = null;
  var dialog = null;
  var yesBtn = null;
  var noBtn = null;
  var pending = null;
  var previousFocus = null;

  function isConfirmed() {
    try { return window.sessionStorage.getItem(STORAGE_KEY) === 'yes'; }
    catch (e) { return false; }
  }

  function setConfirmed() {
    try { window.sessionStorage.setItem(STORAGE_KEY, 'yes'); }
    catch (e) { /* sessionStorage unavailable: current click still continues */ }
  }

  function getFocusable() {
    if (!modal) return [];
    return Array.prototype.slice.call(modal.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function resolvePending(ok) {
    if (!pending) return;
    var resolver = pending.resolve;
    var rejectAction = pending.rejectAction;
    pending = null;
    closeModal();
    if (ok) setConfirmed();
    resolver(ok);
    if (!ok && rejectAction === 'home') {
      window.location.href = HOME_URL;
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('alcohol-age-gate-is-open');
    document.body.classList.remove('alcohol-age-gate-is-open');
    document.removeEventListener('keydown', onKeydown, true);
    if (previousFocus && typeof previousFocus.focus === 'function') {
      try { previousFocus.focus({ preventScroll: true }); } catch (e) { previousFocus.focus(); }
    }
  }

  function onKeydown(e) {
    if (!modal || !modal.classList.contains('is-visible')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopImmediatePropagation();
      resolvePending(false);
      return;
    }
    if (e.key !== 'Tab') return;
    var focusable = getFocusable();
    if (!focusable.length) {
      e.preventDefault();
      if (dialog) dialog.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function showGate(options) {
    options = options || {};
    if (isConfirmed()) return Promise.resolve(true);
    if (!modal) return Promise.resolve(true); // fail-open only if snippet did not render
    if (pending) return pending.promise;

    previousFocus = document.activeElement;
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('alcohol-age-gate-is-open');
    document.body.classList.add('alcohol-age-gate-is-open');
    document.addEventListener('keydown', onKeydown, true);

    var promise = new Promise(function (resolve) {
      pending = {
        resolve: resolve,
        rejectAction: options.rejectAction || (options.context === 'page' ? 'home' : 'stay'),
        promise: null
      };
    });
    pending.promise = promise;

    window.setTimeout(function () {
      var target = yesBtn || dialog;
      if (target && typeof target.focus === 'function') target.focus();
    }, 0);

    return promise;
  }

  function needsAlcoholGate(el) {
    if (!el) return false;
    if (el.getAttribute && el.getAttribute('data-alcohol') === 'true') return true;
    return !!(el.closest && el.closest('[data-alcohol="true"]'));
  }

  function replayClick(el) {
    if (!el || typeof el.click !== 'function') return;
    window.setTimeout(function () { el.click(); }, 0);
  }

  function interceptClick(e) {
    if (isConfirmed()) return;
    var target = e.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-pdp-submit], [data-sticky-atc-trigger], .js-quick-add, .js-cart-stepper [data-stepper-action], button[name="add"], input[name="add"]');
    if (!trigger || !needsAlcoholGate(trigger)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    showGate({ context: 'add', rejectAction: 'stay' }).then(function (ok) {
      if (ok) replayClick(trigger);
    });
  }

  function interceptSubmit(e) {
    if (isConfirmed()) return;
    var form = e.target;
    if (!form || !needsAlcoholGate(form)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    showGate({ context: 'add', rejectAction: 'stay' }).then(function (ok) {
      if (!ok) return;
      var submit = form.querySelector('[data-pdp-submit], button[name="add"], input[name="add"], [type="submit"]');
      if (submit && typeof submit.click === 'function') submit.click();
      else if (typeof form.submit === 'function') form.submit();
    });
  }

  function init() {
    modal = document.getElementById('AlcoholAgeGate');
    if (!modal) return;
    dialog = modal.querySelector('[role="dialog"]');
    yesBtn = modal.querySelector('[data-alcohol-age-yes]');
    noBtn = modal.querySelector('[data-alcohol-age-no]');

    if (yesBtn) yesBtn.addEventListener('click', function () { resolvePending(true); });
    if (noBtn) noBtn.addEventListener('click', function () { resolvePending(false); });

    // Closing by backdrop is intentionally treated as "Nee" so the check cannot be bypassed.
    modal.addEventListener('click', function (e) {
      if (e.target === modal) resolvePending(false);
    });

    document.addEventListener('click', interceptClick, true);
    document.addEventListener('submit', interceptSubmit, true);

    window.CandyAlcoholAgeGate = {
      isConfirmed: isConfirmed,
      require: showGate
    };

    if (cfg.pageRequiresGate && !isConfirmed()) {
      showGate({ context: 'page', rejectAction: 'home' });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
